import { cbi_duplicate_reason_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiDuplicateReasonTypeEnum = (enumValue: cbi_duplicate_reason_type_enum) => {
  switch (enumValue) {
    case cbi_duplicate_reason_type_enum.CHECKSUM:
      return <Trans i18nKey="Enum_CbiDuplicateReasonTypeEnum-CHECKSUM" />;
    case cbi_duplicate_reason_type_enum.INVOICE_NUMBER:
      return <Trans i18nKey="Enum_CbiDuplicateReasonTypeEnum-INVOICE_NUMBER" />;
    case cbi_duplicate_reason_type_enum.MANUAL:
      return <Trans i18nKey="Enum_CbiDuplicateReasonTypeEnum-MANUAL" />;
  }
};

export const translateCbiDuplicateReasonTypeEnum_dynamic = (enumValue: cbi_duplicate_reason_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_duplicate_reason_type_enum.CHECKSUM:
      return t('Enum_CbiDuplicateReasonTypeEnum-CHECKSUM');
    case cbi_duplicate_reason_type_enum.INVOICE_NUMBER:
      return t('Enum_CbiDuplicateReasonTypeEnum-INVOICE_NUMBER');
    case cbi_duplicate_reason_type_enum.MANUAL:
      return t('Enum_CbiDuplicateReasonTypeEnum-MANUAL');
  }
};
